import initialState from '../store/initial-state';
import {
    UPDATE_FILES_LIST,
    UPDATE_ROOT_FOLDER,
    UPDATE_METADATA,
    ADD_FILE_TO_SAVE,
    SAVE_FOLDER_STRUCTURE,
    SAVE_FOLDER_STRUCTURE_SUCCESS,
    SAVE_FOLDER_STRUCTURE_FAILURE,
    SAVE_FILES_IDS,
  } from '../constants/upload-folder-types';
  
export default (state = initialState.uploadFolder, action) => {

    switch (action.type) {
      case UPDATE_FILES_LIST:
          return {
            ...state,
            fileList: action.payload.fileList,
          }
        case UPDATE_ROOT_FOLDER:
          return {
            ...state,
            rootFolder: action.payload.rootFolder
          }
        case UPDATE_METADATA:
          return {
            ...state,
            ...action.payload
          }
        case ADD_FILE_TO_SAVE:
          return {
            ...state,
            fileListToSave: [
              ...state.fileListToSave,
              action.payload
            ]
          }
        case SAVE_FILES_IDS:
          return {
            ...state,
            fileIdsNotification: [
              ...state.fileIdsNotification,
              action.payload.data
            ],
            fileList: [...state.fileList.map(r => {
              return {
                ...r,
                state: r.uuid === action.payload.asset.uuid
                ? 'success'
                : r.state,
                id_return: action.payload.data
              }
            })],
            saveFolderStructureLoading: false,
            saveFolderStructureError: false
          }
        case SAVE_FOLDER_STRUCTURE:
          return {
            ...state,
            saveFolderStructureLoading: true,
            saveFolderStructureError: false
          }
        case SAVE_FOLDER_STRUCTURE_SUCCESS:
          return {
            ...state,
            saveFolderStructureLoading: false,
            saveFolderStructureError: false
          }
        case SAVE_FOLDER_STRUCTURE_FAILURE:
          return {
            ...state,
            saveFolderStructureLoading: false,
            saveFolderStructureError: true
          }
        default:
          return {
            ...state,
          }
    }

}
